import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _8b483b82 = () => interopDefault(import('../../../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _92bbf5ce = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _0d09e6ee = () => interopDefault(import('../../../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _5e6105d5 = () => interopDefault(import('../../../pages/comparison/index.vue' /* webpackChunkName: "pages/comparison/index" */))
const _f0f48cb2 = () => interopDefault(import('../../../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _60dc79aa = () => interopDefault(import('../../../pages/integrations/index.vue' /* webpackChunkName: "pages/integrations/index" */))
const _3c161b66 = () => interopDefault(import('../../../pages/pricing.vue' /* webpackChunkName: "pages/pricing" */))
const _36f66460 = () => interopDefault(import('../../../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _2c2d62f6 = () => interopDefault(import('../../../pages/product.vue' /* webpackChunkName: "pages/product" */))
const _9aef0c7a = () => interopDefault(import('../../../pages/roadmap.vue' /* webpackChunkName: "pages/roadmap" */))
const _6d45111e = () => interopDefault(import('../../../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _056ff3d9 = () => interopDefault(import('../../../pages/support/index.vue' /* webpackChunkName: "pages/support/index" */))
const _08f44b03 = () => interopDefault(import('../../../pages/templates/index.vue' /* webpackChunkName: "pages/templates/index" */))
const _609fc34e = () => interopDefault(import('../../../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _1e397372 = () => interopDefault(import('../../../pages/use-cases/index.vue' /* webpackChunkName: "pages/use-cases/index" */))
const _1a863e1a = () => interopDefault(import('../../../pages/blog/topics/_slug.vue' /* webpackChunkName: "pages/blog/topics/_slug" */))
const _7534f4b0 = () => interopDefault(import('../../../pages/support/topics/_slug.vue' /* webpackChunkName: "pages/support/topics/_slug" */))
const _0b5345a6 = () => interopDefault(import('../../../pages/blog/_slug.vue' /* webpackChunkName: "pages/blog/_slug" */))
const _6449bc3a = () => interopDefault(import('../../../pages/integrations/_slug.vue' /* webpackChunkName: "pages/integrations/_slug" */))
const _03b95291 = () => interopDefault(import('../../../pages/support/_slug.vue' /* webpackChunkName: "pages/support/_slug" */))
const _21a6b602 = () => interopDefault(import('../../../pages/use-cases/_slug.vue' /* webpackChunkName: "pages/use-cases/_slug" */))
const _5caa648d = () => interopDefault(import('../../../pages/comparison/_slug.vue' /* webpackChunkName: "pages/comparison/_slug" */))
const _073da9bb = () => interopDefault(import('../../../pages/templates/_slug.vue' /* webpackChunkName: "pages/templates/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _8b483b82,
    name: "404___en"
  }, {
    path: "/bg",
    component: _92bbf5ce,
    name: "index___bg"
  }, {
    path: "/blog",
    component: _0d09e6ee,
    name: "blog___en"
  }, {
    path: "/comparison",
    component: _5e6105d5,
    name: "comparison___en"
  }, {
    path: "/contact",
    component: _f0f48cb2,
    name: "contact___en"
  }, {
    path: "/es",
    component: _92bbf5ce,
    name: "index___es"
  }, {
    path: "/integrations",
    component: _60dc79aa,
    name: "integrations___en"
  }, {
    path: "/pricing",
    component: _3c161b66,
    name: "pricing___en"
  }, {
    path: "/privacy-policy",
    component: _36f66460,
    name: "privacy-policy___en"
  }, {
    path: "/product",
    component: _2c2d62f6,
    name: "product___en"
  }, {
    path: "/roadmap",
    component: _9aef0c7a,
    name: "roadmap___en"
  }, {
    path: "/search",
    component: _6d45111e,
    name: "search___en"
  }, {
    path: "/support",
    component: _056ff3d9,
    name: "support___en"
  }, {
    path: "/templates",
    component: _08f44b03,
    name: "templates___en"
  }, {
    path: "/terms",
    component: _609fc34e,
    name: "terms___en"
  }, {
    path: "/use-cases",
    component: _1e397372,
    name: "use-cases___en"
  }, {
    path: "/bg/404",
    component: _8b483b82,
    name: "404___bg"
  }, {
    path: "/bg/blog",
    component: _0d09e6ee,
    name: "blog___bg"
  }, {
    path: "/bg/comparison",
    component: _5e6105d5,
    name: "comparison___bg"
  }, {
    path: "/bg/contact",
    component: _f0f48cb2,
    name: "contact___bg"
  }, {
    path: "/bg/integrations",
    component: _60dc79aa,
    name: "integrations___bg"
  }, {
    path: "/bg/pricing",
    component: _3c161b66,
    name: "pricing___bg"
  }, {
    path: "/bg/privacy-policy",
    component: _36f66460,
    name: "privacy-policy___bg"
  }, {
    path: "/bg/product",
    component: _2c2d62f6,
    name: "product___bg"
  }, {
    path: "/bg/roadmap",
    component: _9aef0c7a,
    name: "roadmap___bg"
  }, {
    path: "/bg/search",
    component: _6d45111e,
    name: "search___bg"
  }, {
    path: "/bg/support",
    component: _056ff3d9,
    name: "support___bg"
  }, {
    path: "/bg/templates",
    component: _08f44b03,
    name: "templates___bg"
  }, {
    path: "/bg/terms",
    component: _609fc34e,
    name: "terms___bg"
  }, {
    path: "/bg/use-cases",
    component: _1e397372,
    name: "use-cases___bg"
  }, {
    path: "/es/404",
    component: _8b483b82,
    name: "404___es"
  }, {
    path: "/es/blog",
    component: _0d09e6ee,
    name: "blog___es"
  }, {
    path: "/es/comparison",
    component: _5e6105d5,
    name: "comparison___es"
  }, {
    path: "/es/contact",
    component: _f0f48cb2,
    name: "contact___es"
  }, {
    path: "/es/integrations",
    component: _60dc79aa,
    name: "integrations___es"
  }, {
    path: "/es/pricing",
    component: _3c161b66,
    name: "pricing___es"
  }, {
    path: "/es/privacy-policy",
    component: _36f66460,
    name: "privacy-policy___es"
  }, {
    path: "/es/product",
    component: _2c2d62f6,
    name: "product___es"
  }, {
    path: "/es/roadmap",
    component: _9aef0c7a,
    name: "roadmap___es"
  }, {
    path: "/es/search",
    component: _6d45111e,
    name: "search___es"
  }, {
    path: "/es/support",
    component: _056ff3d9,
    name: "support___es"
  }, {
    path: "/es/templates",
    component: _08f44b03,
    name: "templates___es"
  }, {
    path: "/es/terms",
    component: _609fc34e,
    name: "terms___es"
  }, {
    path: "/es/use-cases",
    component: _1e397372,
    name: "use-cases___es"
  }, {
    path: "/",
    component: _92bbf5ce,
    name: "index___en"
  }, {
    path: "/bg/blog/kategorii/:slug",
    component: _1a863e1a,
    name: "blog-topics-slug___bg"
  }, {
    path: "/bg/support/kategorii/:slug",
    component: _7534f4b0,
    name: "support-topics-slug___bg"
  }, {
    path: "/es/blog/topics/:slug",
    component: _1a863e1a,
    name: "blog-topics-slug___es"
  }, {
    path: "/es/support/topics/:slug",
    component: _7534f4b0,
    name: "support-topics-slug___es"
  }, {
    path: "/bg/blog/:slug",
    component: _0b5345a6,
    name: "blog-slug___bg"
  }, {
    path: "/bg/integracii/:slug",
    component: _6449bc3a,
    name: "integrations-slug___bg"
  }, {
    path: "/bg/pomoshten-centar/:slug",
    component: _03b95291,
    name: "support-slug___bg"
  }, {
    path: "/bg/primeri-za-polzvane/:slug",
    component: _21a6b602,
    name: "use-cases-slug___bg"
  }, {
    path: "/bg/sravnenie/:slug",
    component: _5caa648d,
    name: "comparison-slug___bg"
  }, {
    path: "/bg/templeiti/:slug",
    component: _073da9bb,
    name: "templates-slug___bg"
  }, {
    path: "/blog/topics/:slug",
    component: _1a863e1a,
    name: "blog-topics-slug___en"
  }, {
    path: "/es/blog/:slug",
    component: _0b5345a6,
    name: "blog-slug___es"
  }, {
    path: "/es/casos-de-uso/:slug",
    component: _21a6b602,
    name: "use-cases-slug___es"
  }, {
    path: "/es/comparar/:slug",
    component: _5caa648d,
    name: "comparison-slug___es"
  }, {
    path: "/es/integraciones/:slug",
    component: _6449bc3a,
    name: "integrations-slug___es"
  }, {
    path: "/es/plantillas/:slug",
    component: _073da9bb,
    name: "templates-slug___es"
  }, {
    path: "/es/soporte/:slug",
    component: _03b95291,
    name: "support-slug___es"
  }, {
    path: "/support/topics/:slug",
    component: _7534f4b0,
    name: "support-topics-slug___en"
  }, {
    path: "/blog/:slug",
    component: _0b5345a6,
    name: "blog-slug___en"
  }, {
    path: "/comparison/:slug",
    component: _5caa648d,
    name: "comparison-slug___en"
  }, {
    path: "/integrations/:slug",
    component: _6449bc3a,
    name: "integrations-slug___en"
  }, {
    path: "/support/:slug",
    component: _03b95291,
    name: "support-slug___en"
  }, {
    path: "/templates/:slug",
    component: _073da9bb,
    name: "templates-slug___en"
  }, {
    path: "/use-cases/:slug",
    component: _21a6b602,
    name: "use-cases-slug___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
